import Swiper, { Navigation, Scrollbar } from "swiper";

//inizializza tutti i caroselli offerte (uh/generic-carousels)
export class OfferCarousels {
  constructor() {
    this.init();
  }
  init() {
    document.querySelectorAll<HTMLElement>(".offer-swiper").forEach((res) => {
      this.initializeCarousel(res.id.replace("swiper-", ""));
    });
  }
  initializeCarousel(id: string) {
    console.log("id wisper", id);
    return new Swiper(`#swiper-${id}`, {
      // Optional parameters
      direction: "horizontal",
      allowTouchMove: true,
      modules: [Navigation, Scrollbar],
      resizeObserver: true,
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: "auto",
          // centeredSlides: true,
          centeredSlides: false,
          spaceBetween: 16,
          navigation: {
            nextEl: `.${id}-button-next`,
            prevEl: `.${id}-button-prev`,
          },
          scrollbar: {
            enabled: false,
          },
        },
        768: {
          enabled: true,
          slidesPerView: 3.1,
          // slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          navigation: {
            nextEl: `.${id}-button-next`,
            prevEl: `.${id}-button-prev`,
          },
          scrollbar: {
            enabled: true,
            el: `.${id}-scrollbar`,
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
        992: {
          enabled: true,
          slidesPerView: 3.3,
          // slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          allowTouchMove: false,
          simulateTouch: false,
          navigation: {
            nextEl: `.${id}-button-next`,
            prevEl: `.${id}-button-prev`,
          },
          scrollbar: {
            enabled: true,
            el: `.${id}-scrollbar`,
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
      },
    });
  }
}
